/** Compose one email to a lead — recipient comes from the lead record server-side. */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { EmailEditor } from './EmailEditor';
import { errMsg } from './Templates';

export function ComposeEmail({ leadId, onClose }) {
  const [templates, setTemplates] = useState([]);
  const [m, setM] = useState({ template_id: '', subject: '', format: 'RICH', body: '' });
  useEffect(() => { api.request('/communications/templates').then((r) => setTemplates(r.templates)).catch(() => {}); }, []);
  const send = async () => {
    try { await api.request('/communications/compose', { method: 'POST', body: JSON.stringify({ entity_type: 'lead', entity_id: leadId, ...m }) }); toast.success('Email queued — it sends once your mailbox is connected'); onClose(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" data-testid="compose-email-modal">
      <div className="w-full max-w-2xl space-y-3 rounded-xl bg-background p-5 shadow-xl">
        <div className="flex items-center justify-between"><p className="font-semibold">Compose email</p><button type="button" onClick={onClose} data-testid="compose-close-btn">✕</button></div>
        <select className="h-9 w-full rounded-md border px-3 text-sm" value={m.template_id} onChange={(e) => setM({ ...m, template_id: e.target.value })} data-testid="compose-template">
          <option value="">Write a custom email</option>{templates.map((t) => <option key={t.template_id} value={t.template_id}>{t.name}</option>)}
        </select>
        {!m.template_id && <>
          <div className="flex gap-2">
            <input className="h-9 flex-1 rounded-md border px-3 text-sm" placeholder="Subject" value={m.subject} onChange={(e) => setM({ ...m, subject: e.target.value })} data-testid="compose-subject" />
            <select className="h-9 rounded-md border px-2 text-sm" value={m.format} onChange={(e) => setM({ ...m, format: e.target.value })} data-testid="compose-format"><option value="RICH">Rich</option><option value="PLAIN">Plain text</option></select>
          </div>
          <EmailEditor format={m.format} value={m.body} onChange={(body) => setM((x) => ({ ...x, body }))} testid="compose-body" />
        </>}
        <button type="button" className="h-9 rounded-full bg-primary px-5 text-sm text-primary-foreground" onClick={send} data-testid="compose-send-btn">Send</button>
      </div>
    </div>
  );
}
